import React, { useContext } from 'react';
import cn from 'classnames';
import { tierTypeIds } from '../../summit-program/summit';
import { UserContext } from '../WithUserState/WithUserState';
import getConfig from '../../config';
import styles from './SummitMessage.css';
import lockIconSvg from '../../images/screener-lock-icon.svg';
import unlockIconSvg from '../../images/screener-unlock-icon.svg';
import summitIconSvg from '../../images/summit.svg';

const lockIcon = (
    <img src={lockIconSvg} alt="lock icon" className="lock icon" />
);

const unlockIcon = (
    <img src={unlockIconSvg} alt="unlocked icon" className="unlock icon" />
);

const SummitIcon = () => (
    <React.Fragment>
        <img src={summitIconSvg} alt="summit icon" className="summit icon" />
        <style jsx>{styles}</style>
    </React.Fragment>
);

const linkStyles = {
    textDecoration: 'none',
    color: '#086ea1',
    fontWeight: 'bold'
};

const defaultClosedMsg = (ticker, etf) => {
    const { loggedIn } = useContext(UserContext) || false;
    return (
        <React.Fragment>
            {lockIcon}
            <div>
                One way to get preferred access to closed funds is by achieving
                an appropriate status in the Summit Program.{' '}
                {loggedIn ? (
                    <a
                        id="summit-bene-closedfunds"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Client Benefits"
                        href="https://www.troweprice.com/personal-investing/about/client-benefits/index.html?src=summit-closed-fund"
                        style={linkStyles}
                    >
                        Learn about Summit.
                    </a>
                ) : (
                    <a
                        rel="noopener noreferrer"
                        href={`${getConfig(
                            'envDomain'
                        )}/usis/login/?pdurl=/v0/ciam-public/me%3fsdurl=${getConfig(
                            'envDomain'
                        )}/personal-investing/tools/fund-research/${
                            etf ? 'etf/' : ''
                        }${ticker}`}
                        style={linkStyles}
                    >
                        Log in to see if you qualify.
                    </a>
                )}
            </div>
        </React.Fragment>
    );
};

const openMsg = (
    <React.Fragment>
        {unlockIcon}
        <div>
            You have preferred access to closed funds because of your Summit
            Program status.
        </div>
    </React.Fragment>
);

const closedMap = {
    [tierTypeIds.SELECT]: openMsg,
    [tierTypeIds.PERSONAL_SERVICE]: openMsg,
    [tierTypeIds.ENHANCED_PERSONAL_SERVICE]: openMsg
};

// if PERSONAL_SERVICE, EHANCED_PERSONAL_SERVICE
// SHOW ICLASS MESSAGE OVER CLOSED...
// if there is an iclass benefit show the iclass message overclosed message
const defaultIClassMsg = (ticker, etf) => {
    const { loggedIn } = useContext(UserContext) || false;
    return (
        <React.Fragment>
            <SummitIcon />
            <div>
                One way to get preferred access to lower-cost I Class shares is
                by achieving an appropriate status in the Summit Program.{' '}
                {loggedIn ? (
                    <a
                        id="summit-bene-iclass"
                        target="_blank"
                        rel="noopener noreferrer"
                        title="Client Benefits"
                        href="https://www.troweprice.com/personal-investing/about/client-benefits/index.html?src=summit-iclass"
                        style={linkStyles}
                    >
                        Learn about Summit.
                    </a>
                ) : (
                    <a
                        rel="noopener noreferrer"
                        href={`${getConfig(
                            'envDomain'
                        )}/usis/login/?pdurl=/v0/ciam-public/me%3fsdurl=${getConfig(
                            'envDomain'
                        )}/personal-investing/tools/fund-research/${
                            etf ? 'etf/' : ''
                        }${ticker}`}
                        style={linkStyles}
                    >
                        Log in to see if you qualify.
                    </a>
                )}
            </div>
        </React.Fragment>
    );
};

const iClassMin50AccessMsg = (
    <React.Fragment>
        {unlockIcon}
        <div>
            You have preferred access to lower-cost I Class shares ($50,000
            minimum, per fund) and closed funds because of your Summit Program
            status.
        </div>
    </React.Fragment>
);
const iClassMap = {
    [tierTypeIds.PERSONAL_SERVICE]: iClassMin50AccessMsg,
    [tierTypeIds.ENHANCED_PERSONAL_SERVICE]: iClassMin50AccessMsg
};

const SummitMessage = ({ iClass, ticker, etf, openToNewInvestors }) => {
    const { summitTier, summitTierLoaded } = useContext(UserContext) || {};

    const message =
        (iClass && iClassMap[summitTier]) ||
        (!openToNewInvestors &&
            (closedMap[summitTier] || defaultClosedMsg(ticker, etf))) ||
        (iClass && defaultIClassMsg(ticker, etf));

    const showSummitMessage = summitTierLoaded || message;

    return (
        !etf &&
        (!openToNewInvestors || iClass) && (
            <React.Fragment>
                {/* summit start */}
                <div className="clear-fix" />
                {showSummitMessage && (
                    <div
                        className={cn('summit-notice-wrapper', {
                            loading: !summitTierLoaded
                        })}
                    >
                        {message}
                    </div>
                )}
                <style jsx>{styles}</style>
                {/* summit end */}
            </React.Fragment>
        )
    );
};

export default SummitMessage;
